import React from 'react';

import { computed } from 'mobx';
import { observer } from 'mobx-react';

import { cache } from 'tm3-core/cache';

import type ENestedLookupGlobalIds from 'tm3-core/cache/stores/nested-lookup-store/enums/global-id';
import type { IOption, IProps as SelectProps } from '../field-select';
import FieldSelect from '../field-select';

interface IProps extends Omit<SelectProps, 'items' | 'children'> {
  lookupId: ENestedLookupGlobalIds;
}

export interface INestedLookupFieldSelectProps extends IProps {}

@observer
class NestedLookupFieldSelect extends React.Component<IProps> {
  render() {
    return <FieldSelect valueMember="id" displayMember="id" {...this.props} items={this.items} />;
  }

  @computed
  private get items(): Partial<IOption>[] {
    const { lookupId } = this.props;

    return cache.nestedLookups.GetParsedNestedLookup(lookupId).map((nLookup) => {
      return {
        id: nLookup.description
      };
    });
  }
}

export default NestedLookupFieldSelect;
